import type { GroupListResponse, Group } from '../types/groups';
import { VL_API_BASE_URL } from 'vince-core/constants/backendUrls';
import { APIClient } from 'vince-core/api/apiClient';

const baseUrl = `${VL_API_BASE_URL}/groups`;

export async function loadGroups () {
    return await APIClient<GroupListResponse>(baseUrl);
}

export async function getGroupById (groupId: string) {
    return await APIClient<Group>(`${baseUrl}/${groupId}`);
}

export async function createGroup (group: Group) {
    return await APIClient<Group>(baseUrl, {
        method: 'POST',
        body: JSON.stringify(group)
    });
}
export async function updateGroup (group: Group) {
    return await APIClient<Group>(`${baseUrl}`, {
        method: 'PATCH',
        body: JSON.stringify(group)
    });
}
export async function deleteGroup (group: Partial<Group>) {
    await APIClient<void>(`${baseUrl}/${group.groupId}`, { method: 'DELETE' });
}
